<template>
    <div class="financial-chart">
        <div class="chart-dashbord income-detail">
            <div class="income-chart">
                <div class="chart-dashbord-head">
                    <div class="title">
                        收支情況
                    </div>
                    <ul class="filter-tabs">
                        <li @click="filterEvent('income', 'WEEK')" :class="{active: inComeAndExpenseChart.filter == 'WEEK'}">近七天</li>
                        <li @click="filterEvent('income', 'MONTH')" :class="{active: inComeAndExpenseChart.filter == 'MONTH'}">本月</li>
                        <li @click="filterEvent('income', 'SEASON')" :class="{active: inComeAndExpenseChart.filter == 'SEASON'}">本季</li>
                        <li @click="filterEvent('income', 'YEAR')" :class="{active: inComeAndExpenseChart.filter == 'YEAR'}">本年</li>
                    </ul>
                    <div class="tips">
                        <div>
                            <div class="dot income"></div>
                            收入
                        </div>
                        <div>
                            <div class="dot expense"></div>
                            支出
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="value">
                        <ul>
                            <li v-for="(item, index) in maxTotalSlice" :key="index">{{item}}</li>
                        </ul>
                    </div>
                    <div class="bar-chart-content">
                        <div class="bar-chart-group" 
                            :class="{
                                'week': inComeAndExpenseChart.filter == 'WEEK',
                                'month': inComeAndExpenseChart.filter == 'MONTH',
                                'season': inComeAndExpenseChart.filter == 'SEASON',
                                'year': inComeAndExpenseChart.filter == 'YEAR',
                            }"
                        >
                            <div class="single-bar" v-for="(item, index) in inComeAndExpenseChart.chart" :key="index">
                                <svg class="bar-chart" width="25" height="210" xmlns="http://www.w3.org/2000/svg" version="1.1">
                                    <path class="bar"
                                        @mouseenter="showIncome(index, item.income)"
                                        @mouseleave="hideIncome(index)"
                                        :stroke-dasharray="getBarChartPercent(item.income)+',210'"
                                        stroke="#3942b5" stroke-width="5" stroke-linecap="round"
                                        d="M5 213 V15"
                                    >
                                    </path>
                                    <path class="bar"
                                        @mouseenter="showExpense(index, item.expense)"
                                        @mouseleave="hideExpense(index)"
                                        :stroke-dasharray="getBarChartPercent(item.expense)+',210'"
                                        stroke="#fc7171" stroke-width="5" stroke-linecap="round"
                                        :d="'M'+inComeAndExpenseChart.charPadding+' 213 V15'"
                                    />
                                </svg>
                                <div class="income-amount">收入：$ {{toCurrency(item.income.toFixed(2))}}</div>
                                <div class="expense-amount">支出：$ {{toCurrency(item.expense.toFixed(2))}}</div>
                                <div v-if="inComeAndExpenseChart.filter == 'YEAR'" class="date">
                                    {{toDoubleNum(index+1)}} <span>月</span> 
                                </div>
                                <div v-if="inComeAndExpenseChart.filter == 'SEASON'" class="date">
                                    {{getSeason(index)}} <span>月</span> 
                                </div>
                                <div v-if="inComeAndExpenseChart.filter == 'MONTH'" class="date">
                                    {{toDoubleNum(index+1)}}
                                </div>
                                <div v-if="inComeAndExpenseChart.filter == 'WEEK'" class="date">
                                    {{getDate(Math.abs(index-6)*-1)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="income-group">
                <div class="income-doughnut">
                    <div class="chart-dashbord-head">
                        <div class="title">
                            收支統計
                        </div>
                        <div class="tips">
                            <div>
                                <div class="dot income"></div>
                                收入
                            </div>
                            <div>
                                <div class="dot expense"></div>
                                支出
                            </div>
                        </div>
                    </div>
                    <div class="doughnut-content">
                        <div class="single-chart" :class="{empty: !dounutPercent && isOnlyExpnese == false}">
                            <svg viewBox="0 0 36 36" class="circular-chart">
                                <path class="circle-bg"
                                    d="M18 2.0845
                                    a 15.9155 15.9155 0 0 1 0 31.831
                                    a 15.9155 15.9155 0 0 1 0 -31.831"
                                />
                                <path class="circle"
                                    v-if="!isOnlyExpnese"
                                    :stroke-dasharray="dounutPercent+','+ 100"
                                    d="M18 2.0845
                                    a 15.9155 15.9155 0 0 1 0 31.831
                                    a 15.9155 15.9155 0 0 1 0 -31.831"
                                />
                            </svg>
                        </div>
                    </div>
                    <router-link :to="{ name: 'financialManagementDefault', hash: '#收支列表'}">
                        <div class="total-button">
                            查看所有收支列表
                        </div>
                    </router-link>
                </div>
                <div class="income-statics">
                    <div class="chart-dashbord-head">
                        <div class="title">
                            收支總計
                            <span class="amount-total">{{isIncomePositive}} $ {{inComeAndExpenseChart.income.totalAmount || inComeAndExpenseChart.expense.totalAmount?toCurrency(Math.abs((inComeAndExpenseChart.income.totalAmount - inComeAndExpenseChart.expense.totalAmount)).toFixed(2)):''}}</span>
                        </div>
                    </div>
                    <div class="income-statics-wrap">
                        <div class="left">
                            <div class="sub-title">
                                收入總額
                                <span class="income">
                                    $ {{toCurrency(inComeAndExpenseChart.income.totalAmount)}}
                                </span>
                            </div>
                            <ul>
                                <li v-for="(item, index) in inComeAndExpenseChart.income.detailData" :key="index">
                                    <span>{{transSource(item.type)}}</span>
                                    <span>+ {{toCurrency(item.amount)}}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="right">
                            <div class="sub-title">
                                支出總額
                                <span class="expense">
                                    $ {{toCurrency(inComeAndExpenseChart.expense.totalAmount)}}
                                </span>
                            </div>
                            <ul>
                                <li v-for="(item, index) in inComeAndExpenseChart.expense.detailData" :key="index">
                                    <span>{{transSource(item.type)}}</span>
                                    <span>- {{toCurrency(item.amount)}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="rented-and-arears">
            <div class="chart-dashbord left">
                <div class="chart-dashbord-head">
                    <div class="title">
                        空房率
                    </div>
                    <div class="tips">
                        <div>
                            <div class="dot empty"></div>
                            空房 {{OccupancyChart.notRentedCount}} 間
                        </div>
                        <div>
                            <div class="dot rented"></div>
                            已租 {{OccupancyChart.rentedCount}} 間
                        </div>
                    </div>
                </div>
                <div class="doughnut-content">
                    <div class="single-chart" :class="{empty: !occupancyPercent}">
                        <svg viewBox="0 0 36 36" class="circular-chart">
                            <path class="circle-bg"
                                d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831"
                            />
                            <path class="circle"
                                :stroke-dasharray="occupancyPercent+','+ 100"
                                d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831"
                            />
                        </svg>
                        <div class="percent">
                            {{occupancyPercent}} %
                        </div>
                    </div>
                </div>
                <router-link  :to="{ name: 'HouseManagementDefault', hash: '#未租'}">
                    <div class="total-button">
                        查看所有空房
                    </div>
                </router-link>
            </div>
            <div class="chart-dashbord right">
                <div class="arears">
                    <div class="chart-dashbord-head">
                        <div class="title">
                            應收與未繳
                        </div>
                        <ul class="filter-tabs">
                            <li @click="filterEvent('receivable', 'WEEK')" :class="{active: receivable.filter == 'WEEK'}">近七天</li>
                            <li @click="filterEvent('receivable', 'MONTH')" :class="{active: receivable.filter == 'MONTH'}">本月</li>
                            <li @click="filterEvent('receivable', 'SEASON')" :class="{active: receivable.filter == 'SEASON'}">本季</li>
                            <li @click="filterEvent('receivable', 'YEAR')" :class="{active: receivable.filter == 'YEAR'}">本年</li>
                        </ul>
                    </div>
                    <div class="arrears-total">
                        <div class="all-total">
                            <div class="title">應收總額</div>
                            <div class="amount">$ {{toCurrency(receivable.totalAmount)}}</div>
                        </div>
                        <!-- <div class="divider"></div> -->
                        <div class="paid-total">
                            <div class="title">已收總額</div>
                            <div class="amount">$ {{toCurrency(receivable.paidAmount)}}</div>
                        </div>
                        <!-- <div class="divider"></div> -->
                        <div class="unpay-total">
                            <div class="title">未繳總額</div>
                            <div class="amount">$ {{toCurrency(receivable.unpaidAmount)}}</div>
                        </div>
                    </div>
                    <!-- <ul>
                        <li v-for="(item, index) in receivable.unpaidAmount.detailData" :key="index">
                            <span class="type">{{transSource(item.type)}}未繳</span>
                            <span>$ {{toCurrency(item.amount)}}</span>
                        </li>
                    </ul> -->
                </div>
                <div class="statics">
                    <div class="chart-dashbord-head">
                        <div class="title">
                            收款率
                        </div>
                        <div class="tips">
                            <div>
                                <div class="dot paid"></div>
                                已收款
                            </div>
                            <div>
                                <div class="dot unpay"></div>
                                未繳款
                            </div>
                        </div>
                    </div>
                    <div class="doughnut-content">
                        <div class="single-chart" :class="{empty: !receivablePercent && isOnlyUnpaid == false}" >
                            <svg viewBox="0 0 36 36" class="circular-chart">
                                <path class="circle-bg"
                                    d="M18 2.0845
                                    a 15.9155 15.9155 0 0 1 0 31.831
                                    a 15.9155 15.9155 0 0 1 0 -31.831"
                                />
                                <path class="circle"
                                    v-if="!isOnlyUnpaid"
                                    :stroke-dasharray="receivablePercent+','+ 100"
                                    d="M18 2.0845
                                    a 15.9155 15.9155 0 0 1 0 31.831
                                    a 15.9155 15.9155 0 0 1 0 -31.831"
                                />
                            </svg>
                        </div>
                        <div class="percent">
                            {{receivablePercent}} %
                        </div>
                    </div>
                    <router-link  :to="{ name: 'financialBill'}">
                        <div class="total-button">
                            查看所有帳單
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { 
    apiGetIncomeAndExpenditureStatistics,
    apiGetOccupancyRate,
    apiGetReceivable
    } from "@/apis/api.js";
export default {
    data () {
        return {
            inComeAndExpenseChart: {
                filter: 'WEEK',
                charPadding: 17,
                income:{
                },
                expense:{
                },
                dounutPercent: 0,
                chart:[]
            },
            OccupancyChart: {},
            receivable: {
                filter: 'WEEK',
                paidAmount: 0,
                unpaidAmount: 0,
                totalAmount: 0,
            }
        }
    },
    mounted () {
        this.getIncomeAndExpenditureStatistics()
        this.getReceivable()
        this.getOccupancyRate()
    },
    watch: {
        'inComeAndExpenseChart.filter': function (value) {
            this.getIncomeAndExpenditureStatistics()
            if(value == 'MONTH'){
                this.inComeAndExpenseChart.charPadding = 11
            }else{
                this.inComeAndExpenseChart.charPadding = 17
            }
        },
        'receivable.filter': function (value) {
            this.getReceivable()
        }
    },
    methods: {
        getIncomeAndExpenditureStatistics: function () {
            let data = this.inComeAndExpenseChart.filter
            if(data == 'WEEK'){
                this.inComeAndExpenseChart.chart = [
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                ]
            }else if(data == 'MONTH'){
                this.inComeAndExpenseChart.chart = [
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                ]
            }else if(data == 'SEASON'){
                this.inComeAndExpenseChart.chart = [
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                ]
            }else if(data == 'YEAR'){
                this.inComeAndExpenseChart.chart = [
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                ]
            }
           
            apiGetIncomeAndExpenditureStatistics(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.inComeAndExpenseChart.chart = res.data.result.analysisData
                    this.inComeAndExpenseChart.expense = res.data.result.expenseData
                    this.inComeAndExpenseChart.income = res.data.result.incomeData
                    this.inComeAndExpenseChart.totalAmount = res.data.result.totalAmount
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getReceivable: function () {
            let data = this.receivable.filter
            apiGetReceivable(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.receivable.paidAmount = res.data.result.paidAmount
                    this.receivable.unpaidAmount = res.data.result.unpaidAmount
                    this.receivable.totalAmount = res.data.result.totalAmount
                    
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getOccupancyRate: function () {
            apiGetOccupancyRate()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.OccupancyChart = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getDecimal: function (value) {
            let numLength = value.toString().length
            let toDecimal = ''
            for (let i = 0; i < numLength-3; i++) {
                toDecimal += '0'
            }
            toDecimal = '0.'+toDecimal+'1'
            return parseFloat(toDecimal)
        },
        getInteger: function (value) {
            let numLength = value.toString().length
            let toInteger = ''
            for (let i = 0; i < numLength-2; i++) {
                toInteger += '0'
            }
            toInteger = '1'+toInteger
            return parseInt(toInteger)
        },
        getBarChartPercent: function (value) {
            let maxTotal = this.carryNum?this.carryNum:40000
            return (value/maxTotal)*210
        },
        getMax: function (value) {
            let max = 0
            for (let i = 0; i < value.length; i++) {
                const element = value[i];
                if (element.expense > max) {
                    max = element.expense;
                }
            }
            for (let i = 0; i < value.length; i++) {
                const element = value[i];
                if (element.income > max) {
                    max = element.income;
                }
            }
            return max
        },
        getDate: function (index) {
            let date = new Date()
            let newDate = new Date()
            newDate.setDate(date.getDate() + index)
            let time = (newDate.getMonth()+1)+'.'+newDate.getDate()

            return time
        },
        getSeason: function (index) {
            let today = new Date()
            let nowMonth = today.getMonth()+1
            let season = []
            if( nowMonth <= 3 ){
                season = [1,2,3]
            }else if(nowMonth >= 4 && nowMonth <= 6){
                season = [4,5,6]
            }else if(nowMonth >= 7 && nowMonth <= 9){
                season = [7,8,9]
            }else if(nowMonth >= 10 && nowMonth <= 12){
                season = [10,11,12]
            }
            return this.toDoubleNum(season[index])

        },
        filterEvent: function (type, filter) {
            if(type == 'income'){
                this.inComeAndExpenseChart.filter = filter
            }else if( type == 'receivable'){
                this.receivable.filter = filter
            }
        },
        showIncome: function(index, value) {
            console.log(document.getElementsByClassName('income-amount'))
            let incomeItem = document.getElementsByClassName('income-amount')[index]
            let barHeight = this.getBarChartPercent(value)+10
            incomeItem.style.bottom = barHeight+'px'
            incomeItem.style.display = 'flex'
        },
        hideIncome: function(index, value) {
            let incomeItem = document.getElementsByClassName('income-amount')[index]
            incomeItem.style.display = 'none'
        },
        showExpense: function(index, value) {
            let expenseItem = document.getElementsByClassName('expense-amount')[index]
            let barHeight = this.getBarChartPercent(value)+10
            expenseItem.style.bottom = barHeight+'px'
            expenseItem.style.display = 'flex'
        },
        hideExpense: function(index, value) {
            let expenseItem = document.getElementsByClassName('expense-amount')[index]
            expenseItem.style.display = 'none'
        },
        // transSource: function (value) {
        //     if(value == 'BOOKING_DEPOSIT'){
        //         return '訂金'
        //     }else if(value == 'CONTRACT_DEPOSIT'){
        //         return '押金'
        //     }else if(value == 'CONTRACT_BILL'){
        //         return '帳單'
        //     }else if(value == 'CONTRACT_DEPOSIT'){
        //         return '訂金'
        //     }else if(value == 'HOUSE_LEDGER'){
        //         return '記帳'
        //     }else if(value == 'HOUSE_TASK_BONUS'){
        //         return '委託獎金'
        //     }else if(value == 'RETURN_PAID_HOUSE_TASK_BONUS'){
        //         return '委託退款'
        //     }else if(value == 'BOOKING_DEPOSIT_FOR_TENANT_REJECT'){
        //         return '取消預定'
        //     }
        // },
        toDoubleNum: function (value) {
            return (Array(2).join(0)+value).slice(-2)
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
        maxTotalSlice: function () {
            let maxTotal  = this.carryNum?this.carryNum:40000
            
            let slice = []
            for (let i = 0; i <= 4; i++) {
                // console.log((maxTotal/4)*i)
                slice[i] = (maxTotal/4)*i
            }
            return slice.reverse()
        },
        carryNum: function (value) {
            
            let maxValue  = parseInt(this.maxValue)
            let toMutiple = maxValue*1.1
            let toDecimal = this.getDecimal(maxValue)
            let toInteger = this.getInteger(maxValue)

            

            let toCeil = Math.ceil(toMutiple*toDecimal)
            let toMaxTotal = toCeil*toInteger
            // console.log('最高金額:'+maxValue)
            // console.log('最高金額*1.1:'+toMutiple)
            // console.log('變小數:'+toDecimal)
            // console.log('無條件進位:'+toInteger)
            // console.log('還原:'+toCeil)
            // console.log(toDecimal)
            // console.log(toInteger)
            // console.log(toMaxTotal)
            return toMaxTotal
        },
        maxValue: function (){
            let chart = this.inComeAndExpenseChart.chart
            return this.getMax(chart)
        },
        dounutPercent: function () {
            let income = parseInt(this.inComeAndExpenseChart.income.totalAmount)
            let expense = parseInt(this.inComeAndExpenseChart.expense.totalAmount)

            let percent = parseInt((income/(income+expense))*100)

            if(percent){
                return percent
            }else{
                return 0
            }
        },
        isOnlyExpnese: function () {
            let income = parseInt(this.inComeAndExpenseChart.income.totalAmount)
            let expense = parseInt(this.inComeAndExpenseChart.expense.totalAmount)
            // console.log(income)
            // console.log(expense)
            if(expense > income && income == 0){
                return true
            }else{
                return false
            }
        },
        occupancyPercent: function () {
            let rented = parseInt(this.OccupancyChart.rentedCount)
            let empty = parseInt(this.OccupancyChart.notRentedCount)

            let percent = parseInt((empty/(rented+empty))*100)
            if(percent){
                return percent
            }else{
                return 0
            }
        },
        receivablePercent: function () {
            let paid = parseInt(this.receivable.paidAmount)
            let unpaid = parseInt(this.receivable.unpaidAmount)
            let percent = parseInt((paid/(paid+unpaid))*100)
            
            if(percent){
                return percent
            }else{
                return 0
            }
        },
        isOnlyUnpaid: function () {
            let paid = parseInt(this.receivable.paidAmount)
            let unpaid = parseInt(this.receivable.unpaidAmount)
            // console.log(income)
            // console.log(expense)
            if(unpaid > paid && paid == 0){
                return true
            }else{
                return false
            }
        },
        isIncomePositive: function () {
            let income = parseInt(this.inComeAndExpenseChart.income.totalAmount)
            let expense = parseInt(this.inComeAndExpenseChart.expense.totalAmount)

            if( (income - expense) >= 0 ){
                return '+'
            }else{
                return '-'
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.financial-chart{
    position: relative;
    width: 1154px;
    .income-amount,
    .expense-amount{
        position: absolute;
        display: none;
        align-items: center;
        justify-content: center;
        min-width: 115px;
        left: 7px;
        border-radius: 4px;
        background-color: #676362;
        color: #fff;
        font-size: 12px;
        padding: 8px 3px;
        z-index: 20;
    }
    .expense-amount{
        left: 21px;
    }
    .income-amount::before,
    .expense-amount::before{
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        left: -4px;
        border-style: solid;
        border-width: 3px 4px 3px 0;
        border-color: transparent #676362 transparent transparent;
    }
    .chart-dashbord{
        background: #fff;
        border-radius: 8px;
        box-shadow: 2px 2px 8px 0 rgba(41, 38, 37, 0.08);
        .chart-dashbord-head{
            display: flex;
            align-items: center;
        }
        .title{
            font-size: 20px;
            font-weight: 500;
        }
        .filter-tabs{
            display: flex;
            align-items: center;
            li{
                display: flex;
                align-items: center;
                justify-content: center;
                height: 26px;
                border-radius: 3px;
                border: solid 1px #e0dfde;
                color: #a8a5a4;
                padding: 0px 16px;
                margin-right: 12px;
                font-size: 12px;
                cursor: pointer;
            }
            li.active{
                background-color: #ff9275;
                border: solid 1px #ff9275;
                color: #fff;
            }
        }
        .tips{
            display: flex;
            align-items: center;
            >div{
                display: flex;
                align-items: center;
                color: #676362;
                font-size: 12px;
                .dot{
                    position: relative;
                    background: #000;
                    width: 7px;
                    height: 7px;
                    border-radius: 4.5px;
                    margin-right: 8px;
                }
            }
        }
    }
    .income-chart{
        border-bottom: solid 1px #f3f3f3;
        padding: 24px 30px;
        padding-bottom: 50px;
        .tips{
            position: absolute;
            right: 30px;
            >div{
                margin-left: 20px;
            }
            .dot.income{
                background: #3942b5;
            }
            .dot.expense{
                background: #fc7171;
            }
        }
        .filter-tabs{
            margin-left: 30px;
        }
        .content{
            display: flex;
            align-items: flex-end;
            .value{
                margin-right: 12px;
                position: relative;
                bottom: -10px;
                li{
                    text-align: center;
                    color: #a8a5a4;
                    line-height: 1.83;
                    font-size: 12px;
                    margin-top: 32px;
                }
            }
            .bar-chart-content{
                width: 1048px;
                height: 211px;
                background-image: url('../../../assets/img/component/financial_chart/chart_dash.png');
                .bar-chart-group{
                    position: relative;
                    display: flex;
                    align-items: flex-end;
                    bottom: 2px;
                    margin-left: 40px;
                    .date{
                        color: #676362;
                        margin-top: 7px;
                    }
                }
                .bar-chart-group.week{
                    margin-left: 60px;
                    .single-bar{
                        margin-right: 58px;
                    }
                    .single-bar:nth-child(even){
                        .date{
                            color: #a8a5a4;
                        }
                    }
                }
                .bar-chart-group.month{
                    margin-left: 10px;
                    .single-bar{
                        margin-right: 9px;
                    }
                    .single-bar:nth-child(even){
                        .date{
                            color: #a8a5a4;
                        }
                    }
                }
                .bar-chart-group.season{
                    margin-left: 60px;
                    .single-bar{
                        margin-right: 58px;
                        .date{
                            >span{
                                font-size: 10px;
                            }
                        }
                    }
                }

                .bar-chart-group.year{
                    margin-left: 60px;
                    .single-bar{
                        margin-right: 50px;
                        .date{
                            width: 31px;
                            >span{
                                font-size: 10px;
                            }
                        }
                    }
                }

            }
        }
        .chart-date{
            margin-top: 12px;
            margin-left: 100px;
            ul{
                display: flex;
                align-items: center;
                li{
                    color: #676362;
                    margin-right: 50px;
                }
            }
        }
    }
    .income-group{
        display: flex;
        .income-doughnut{
            position: relative;
            padding: 24px 30px;
            width: 300px;
            border-right: solid 1px #f3f3f3;
            .tips{
                position: absolute;
                right: 24px;
                >div{
                    margin-left: 20px;
                }
                .dot.income{
                    background: #3942b5;
                }
                .dot.expense{
                    background: #fc7171;
                }
            }
            .circle-bg {
                fill: none;
                stroke: #fc7171;
                stroke-width: 3.2;
            }
            .circle {
                fill: none;
                stroke-width: 3.2;
                stroke-linecap: round;
                animation: progress 1s ease-out forwards;
                stroke: #3942b5;
            }
        }
        .income-statics{
            padding: 24px 30px;
            .amount-total{
                font-size: 24px;
                font-weight: 500;
            }
            .income-statics-wrap{
                display: flex;
                >div{
                    width: 300px;
                    margin-right: 100px;
                    .sub-title{
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        color: #676362;
                        margin-top: 24px;
                        margin-bottom: 16px;
                        >span{
                            font-size: 20px;
                            margin-left: 8px;
                        }
                        >span.income{
                            color: #3942b5;
                        }
                        >span.expense{
                            color: #fc7171;
                        }
                    }
                    ul{
                        li{
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            
                            padding: 9px 12px;
                            border-radius: 4px;
                            border: solid 1px #f3f3f3;
                            margin-bottom: 12px;
                        }
                    }
                }
            }
        }
    }
    .rented-and-arears{
        display: flex;
        margin-top: 30px;
        .left{
            position: relative;
            margin-right: 30px;
            padding: 24px 30px;
            .tips{
                position: absolute;
                right: 30px;
                >div{
                    margin-left: 20px;
                }
                .dot.rented{
                    background: #e0dfde;
                }
                .dot.empty{
                    background: #676362;
                }
            }
            .doughnut-content{
                .single-chart {
                    .circle-bg {
                        stroke: #e0dfde;
                    }
                    .circle {
                        stroke: #676362;
                    }
                }
            }
        }
        .right{
            display: flex;
            width: 814px;
            .arears{
                width: 443px;
                padding: 24px 30px 30px 30px;
                border-right: 1px solid #f3f3f3;
                .chart-dashbord-head{
                    align-items: flex-start;
                    justify-content: flex-start;
                    flex-direction: column;
                    margin-bottom: 50px;
                    .title{
                        margin-bottom: 20px;
                    }
                }
                .arrears-total{
                    // display: flex;
                    // align-items: center;
                    >div{
                        display: flex;
                        align-items: center;
                        margin-bottom: 40px;
                        .title{
                            color: #676362;
                            font-size: 12px;
                            margin-right: 8px;
                        }
                        .amount{
                            font-size: 20px;
                            width: 135px;
                            text-align: right;
                        }
                    }
                    .unpay-total{
                        margin-bottom: 0px;
                    }
                    .all-total > .amount{
                        color: #676362;
                    }
                    .paid-total > .amount{
                        color: #71aae5;
                    }
                    .unpay-total > .amount{
                        color: #fcb773;
                    }
                    .divider{
                        height: 30px;
                        width: 1px;
                        background: #f3f3f3;
                        margin: 0 20px;
                    }
                }
                >ul{
                    display: flex;
                    flex-wrap: wrap;
                    li{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 190px;
                        padding: 9px 12px;
                        border-radius: 4px;
                        border: solid 1px #f3f3f3;
                        margin-bottom: 12px;
                        .type{
                            font-size: 12px;
                        }
                    }
                    li:nth-child(odd){
                        margin-right: 11px;
                    }
                }
            }
            .statics{
                position: relative;
                padding: 24px 30px 30px 30px;
                .tips{
                    position: absolute;
                    right: 30px;
                    >div{
                        margin-left: 20px;
                    }
                    .dot.paid{
                        background: #71aae5;
                    }
                    .dot.unpay{
                        background: #fcb773;
                    }
                }
                .doughnut-content{
                    .single-chart {
                        .circle-bg {
                            stroke: #fcb773;
                        }
                        .circle {
                            stroke: #71aae5;
                        }
                    }
                }
            }
        }
    }
    .total-button{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 250px;
        height: 44px;
        border-radius: 4px;
        background-color: #f3f3f3;
    }
    .doughnut-content{
        position: relative;
        margin-top: 40px;
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        .percent{
            position: absolute;
            width: 100px;
            text-align: center;
            font-size: 28px;
            color: #a8a5a4;
            top: 56px;
            left: 75px;
        }
    }
    .single-chart {
        width: 125px;
        justify-content: space-around ;
        
        .circular-chart {
            display: block;
            margin: 10px auto;
        }
        .circle-bg {
            fill: none;
            stroke: #fc7171;
            stroke-width: 3.3;
        }
        .circle {
            fill: none;
            stroke-width: 3.3;
            stroke-linecap: round;
            animation: progress 1s ease-out forwards;
            stroke: #3942b5;
        }
    }
    .single-chart.empty {
        .circle-bg {
            stroke: #e0dfde !important;
        }
        .circle {
            stroke: #e0dfde !important;
        }
    }
    .single-bar{
        bottom: -3px;
        position: relative;
        .bar {
            animation: bar-progress 1s ease-out forwards;
        }
    }
    @keyframes progress {
        0% {
            stroke-dasharray: 0 100;
        }
    }
    @keyframes bar-progress {
        0% {
            stroke-dasharray: 0 200;
        }
    }
    
}
    
</style>


// WEBPACK FOOTER //
// src/components/landlord/financialManagement/financialChart.vue